export default __webpack_public_path__ + "static/media/grid.519885f8.svg";